{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Grid",
			"rotation": [-0.18906570971012115, 0.34059807658195496, -0.43954890966415405, 0.8093478083610535],
			"scale": [1.923425316810608, 1.923425316810608, 1.923425316810608],
			"translation": [-0.15689705312252045, 1.7845360040664673, -0.03921491652727127]
		},
		{
			"mesh": 1,
			"name": "Cube",
			"rotation": [0, -0.34584367275238037, 0, 0.9382921457290649],
			"scale": [0.2241940051317215, 0.2241939902305603, 0.2241940051317215],
			"translation": [1.8086014986038208, 0.10159873962402344, 0.46138063073158264]
		},
		{
			"mesh": 2,
			"name": "Cube.001",
			"rotation": [0, -0.3420201539993286, 0, 0.9396927356719971],
			"scale": [0.23782891035079956, 0.23782886564731598, 0.23782891035079956],
			"translation": [0.25031495094299316, 0.10159873217344284, -1.0688308477401733]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8055132031440735, 0.8055132031440735, 0.8055132031440735, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.005",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.11602090299129486, 0.10492639243602753, 0.10244207084178925, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Grid",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				}
			]
		},
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 1
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 161,
			"max": [1.0640606880187988, 0.11505399644374847, 1.2367002964019775],
			"min": [-1.416853904724121, -0.09324460476636887, -1.16011381149292],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 161,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 161,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 282,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 100,
			"max": [2.2348694801330566, 1, 1.8743300437927246],
			"min": [-5.834423542022705, -1.0008032321929932, -2.1370062828063965],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 100,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 100,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 168,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 94,
			"max": [1.3639010190963745, 0.464508056640625, 1.28249192237854],
			"min": [-7.669841766357422, -1, -2.219116449356079],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 94,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 94,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 156,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 1932,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1932,
			"byteOffset": 1932,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1288,
			"byteOffset": 3864,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 564,
			"byteOffset": 5152,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1200,
			"byteOffset": 5716,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1200,
			"byteOffset": 6916,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 800,
			"byteOffset": 8116,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 336,
			"byteOffset": 8916,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1128,
			"byteOffset": 9252,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1128,
			"byteOffset": 10380,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 752,
			"byteOffset": 11508,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 312,
			"byteOffset": 12260,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 12572,
			"uri": "spider%20web.bin"
		}
	]
}
